import React from 'react';
import PlannedUsersSearch from '../search';

const ApprovedPlannedUsers = ({ trainingPlanIid }) => {
  return <PlannedUsersSearch showApproved trainingPlanIid={trainingPlanIid} />;
};

export default ApprovedPlannedUsers;
